import { SimulationConfiguration } from '../../predictor/interfaces/simulation-configuration';
import { ScenarioData } from '../../predictor/interfaces/scenario-batch-simulation-request';

export namespace SimulationTrackerActions {
  export class AddSimulationTrackers {
    static readonly type = `[Simulation Tracker] track new simulation`;
    constructor(public terrainId: string, public studyAreaId: string) {}
  }

  export class GetSimulationTracker {
    static readonly type = `[Simulation Tracker] get simulation tracker`;
    constructor(public simulationTrackerId: string) {}
  }

    export class IsSimulationNameAvailable {
    static readonly type = `[Simulation Tracker] check if simulation name exist`;
    constructor(public simulationName: string) {}
  }

  export class SelectSimulationTracker {
    static readonly type = `[Simulation Tracker] select simulation`;
    constructor(public simulationTrackerId: string) {}
  }

  export class GetSimulationTrackersByScnenario {
    static readonly type = `[Simulation Tracker] get trackers by scenario`;
    constructor(public scenarioId?: string) {}
  }

  export class GetSimulationTrackers {
    static readonly type = `[Simulation Tracker] get simulation trackers`;
  }

  export class CreateSimulationBatch {
    static readonly type = `[Simulation] create simulation batch`;
    constructor(
      public simulationId: string,
      public configuration: SimulationConfiguration,
    ) {}
  }

  export class CreateSimulationRunGroup {
    static readonly type = `[Simulation] create simulation run group`;
    constructor(
      public simulationId: string,
       public simulationName: string,
      public iterations: number,
      public runGroup: ScenarioData[],
      public name: string
    ) {}
  }

  export class FavoriteSimulationTracker {
    static readonly type = `[Simulation Tracker] favorite simulation tracker`;
    constructor(public simulationTrackerId: string) {}
  }

  export class RemoveFavoritedSimulationTracker {
    static readonly type = `[Simulation Tracker] remove favorited simulation tracker`;
    constructor(public simulationTrackerId: string) {}
  }

  export class GetFavoritedSimulationTrackers {
    static readonly type = `[Simulation Tracker] get favorited simulation trackers`;
  }

  export class DeleteMultipleSimulationTracker {
    static readonly type = `[Simulation Tracker] delete multiple simulation tracker`;
    constructor(public simulationTrackerIds: string[]) {}
  }

  export class RemoveCompletedSimulationTrackersFromSession {
    static readonly type = `[Simulation Tracker] remove completed simulation trackers from session`;
  }

  export class AddLatestSimulationTrackerToSession {
    static readonly type = `[Simulation Tracker] add latest simulation tracker to session`;
  }
}
